/**
 * CandidateClaimBadge — Reusable badge yang menjelaskan status klaim
 * sebuah sheet row kandidat untuk panel record tertentu.
 *
 * 3 state:
 *   - "actual" → ✓ AKTUAL MATCH (hijau) — pasangan asli record ini
 *   - "claimed" → 🔒 DI-CLAIM [user] (abu-abu) — row dimenangkan panel lain
 *   - "available" → ⊙ FALLBACK · UNCLAIMED (biru) — alternatif tersedia
 *
 * Pakai di RecordDetailPage, ReviewQueuePage, dan tempat lain yg list
 * kandidat. Konsisten visual + label di seluruh sistem.
 */
export function CandidateClaimBadge({ candidate, size = "sm" }) {
  const isActual = !!candidate.selected;
  const claimedBy = candidate.claimed_by;
  const cls = size === "xs" ? "text-[9px] px-1.5 py-0.5" : "text-[10px] px-2 py-1";

  if (isActual) {
    return (
      <span data-testid="candidate-badge-selected"
        className={`font-bold text-emerald-700 bg-emerald-100 uppercase tracking-wider rounded-sm ${cls}`}>
        ✓ AKTUAL MATCH
      </span>
    );
  }
  if (claimedBy) {
    return (
      <span data-testid="candidate-badge-claimed"
        className={`font-bold text-zinc-500 bg-zinc-100 uppercase tracking-wider rounded-sm ${cls}`}
        title={`Di-claim ${claimedBy.username} @ ${claimedBy.transaction_date} (${claimedBy.final_status}, score ${claimedBy.score})`}>
        🔒 DI-CLAIM {claimedBy.username}
      </span>
    );
  }
  return (
    <span data-testid="candidate-badge-available"
      className={`font-bold text-blue-700 bg-blue-50 uppercase tracking-wider rounded-sm ${cls}`}>
      ⊙ FALLBACK · UNCLAIMED
    </span>
  );
}

/**
 * CandidateClaimInfo — Detail strip yang muncul di bawah badge
 * untuk kasus DI-CLAIM (info siapa winner-nya).
 */
export function CandidateClaimInfo({ candidate }) {
  const c = candidate.claimed_by;
  if (!c) return null;
  return (
    <div className="text-[11px] font-mono text-zinc-500 bg-white border border-zinc-200 rounded-sm px-2 py-1.5">
      <span className="text-zinc-400">Row ini sudah dimenangkan oleh:</span>{" "}
      <span className="font-semibold text-zinc-700">{c.username}</span>
      {c.transaction_date && <>{" · "}<span>{c.transaction_date}</span></>}
      {c.final_status && <>{" · "}<span className="text-emerald-600">{c.final_status}</span></>}
      {c.score != null && <>{" · score "}<span>{c.score}</span></>}
    </div>
  );
}

/**
 * Helper: derive border-style className dari state kandidat.
 */
export function candidateRowClass(candidate, isInteractive = false) {
  const isActual = !!candidate.selected;
  const claimedBy = candidate.claimed_by;
  if (isActual) return "bg-emerald-50/50 border-l-2 border-emerald-500";
  if (claimedBy) return "bg-zinc-50/60 border-l-2 border-zinc-300 opacity-80";
  return isInteractive
    ? "bg-blue-50/30 border-l-2 border-blue-200 hover:bg-blue-50/60"
    : "bg-blue-50/30 border-l-2 border-blue-200";
}
